export const getEnv = () => window.location.hostname.replace('connect.', '');

export const isDev = () => process.env.REACT_APP_ENV === 'dev';
export const isDocker = () => process.env.REACT_APP_ENV === 'docker';
export const isUat = () => window.location.hostname.includes('livestage');
export const isLocal = () => isDev() || isDocker();
export const isProd = () => process.env.REACT_APP_RUN_ENV === 'production';
export const getLDClientId =
    process.env.REACT_APP_RUN_ENV === 'production'
        ? '5cd3984b4debbe081e2b9bcb'
        : isUat()
          ? '5d101aa67108380775283307'
          : '5cd3984b4debbe081e2b9bca';
